@if (component.reports.length === 1) {
  <wct-fundsportrait-type-mapper
    *rptHandleErrors
    wctElementCountWatcher
    [documentId]="component.documentId"
    [reportIndex]="component.reports[0]"
    [type]="component.types[0]" />
} @else {
  <div class="horizontal-even">
    @for (reportIndex of component.reports; track reportIndex) {
      <wct-fundsportrait-type-mapper
        *rptHandleErrors
        wctElementCountWatcher
        [documentId]="component.documentId"
        [reportIndex]="reportIndex"
        [type]="component.types[$index]" />
    }
  </div>
}
